// extracted by mini-css-extract-plugin
module.exports = {"section":"VL2dtGSN","message":"MuQxFq7U"};